import React, { Fragment } from 'react';
import { Alert } from '@material-ui/lab';

export function ErrorBlock({ msg = '' }) {
  return <Alert severity="error">{msg}</Alert>;
}

export default ({ info = {}, errors = {} }) => {
  return (
    <Fragment>
      {info.msg && (
        <div className="col-xs-12 info-modal" role="alert">
          {info.msg}
        </div>
      )}

      {errors.login && (
        <ErrorBlock msg={errors.msg} />
      )}
      {errors.already_signed && (
        <ErrorBlock msg="Vous êtes déjà inscrit. Veuillez vous connecter." />
      )}
      {errors.first_name_empty && <ErrorBlock msg="Erreur dans le prénom." />}
      {errors.password_empty && (
        <ErrorBlock msg="Erreur dans le mot de passe." />
      )}
      {errors.email_invalid && <ErrorBlock msg="Erreur dans l'email." />}
      {errors.school_invalid && <ErrorBlock msg="Erreur dans la formation." />}
      {errors.signup_invalid && (
        <ErrorBlock msg="Une erreur est survenue devant l'inscription." />
      )}
    </Fragment>
  );
};

// const ErrorBlock = ({ msg }) => (
//   <div className="alert alert-danger col-xs-12" role="alert">
//     {msg || ''}
//   </div>
// );
